import { render, staticRenderFns } from "./TenderEditTabConsultations.vue?vue&type=template&id=359d8bd5&scoped=true&"
import script from "./TenderEditTabConsultations.vue?vue&type=script&lang=js&"
export * from "./TenderEditTabConsultations.vue?vue&type=script&lang=js&"
import style0 from "./TenderEditTabConsultations.vue?vue&type=style&index=0&id=359d8bd5&lang=scss&scoped=true&"
import style1 from "./TenderEditTabConsultations.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359d8bd5",
  null
  
)

export default component.exports